// import {LoadingSkeleton} from "React"

import {Flex, Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import React from "react";

const Loading = () => {
  // You can add any UI inside Loading, including a Skeleton.

  return <div>
    <div style={{backgroundColor: "#000", position:"fixed", opacity: 1.0, top: 0, bottom: 0, left: 0, right: 0, zIndex: 999999}}>
      <Flex align="center" gap="middle" justify={"center"} style={{height: "100%"}}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: "#FFF" }} spin />} />
      </Flex>
    </div>
  </div>
}

export default Loading